import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSelectedGoalUID } from '@api/hooks/topology/useSelectedGoal';
import { showTTUOption } from '@api/fetchers/ttu';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getMeUid } from '@api/selectors/auth';
import { useIsMobile, usePageInfo } from '@stores/AppCommonData';

const useTTUOptions = () => {
  const { query } = useRouter();

  const uid = useMyInfo(getMeUid);
  const isMobile = useIsMobile();
  const selectedGoalUID = useSelectedGoalUID();
  const { disableTTU } = usePageInfo();

  const goalUID = query.goalUID || selectedGoalUID;

  useEffect(() => {
    if (uid) {
      const shouldFetchTTUOptions = !disableTTU && goalUID && !isMobile;
      if (shouldFetchTTUOptions) showTTUOption(goalUID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid]);

  return null;
};

export default useTTUOptions;
